import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { deleteKolOption, getKolOptions } from "../../../apis/optionKol";
import { toastify } from "../../../helperFunctions/toastify";
import { customStringSort } from "../../../helperFunctions/utils";
import DeleteModal from "../../SharedComponents/DeleteModal";
import FilterComponent from "../../SharedComponents/FilterComponent";

function OptionKol() {
	const navigate = useNavigate();
	const [kols, setKols] = useState([]);
	const [filteredData, setFilteredData] = useState([]);
	const [show, setShow] = useState(false);
	const [deleting, setDeleting] = useState("");

	const handleClose = () => {
		setShow(false);
		setDeleting("");
	};

	const getKolsList = async () => {
		const response = await getKolOptions();
		if (response.status !== "Fail") {
			setKols(response.reverse());
		} else {
			if (response?.message === "No data Found") {
				setKols([]);
			} else {
				toastify(response?.message, "error");
			}
		}
	};

	const removeKol = async () => {
		setShow(false);
		let response = await deleteKolOption(deleting);
		if (response?.status !== "Fail") {
			getKolsList();
			toastify("KOL Option deleted successfully!", "success");
		} else {
			toastify(response?.message, "error");
		}
	};

	const editKol = (e) => {
		navigate("/add-option-kol", {
			state: {
				kol: e,
			},
		});
	};

	const addKol = () => {
		navigate("/add-option-kol");
	};

	useEffect(() => {
		getKolsList();
	}, []);

	const columns = [
		{
			name: (
				<div className="d-flex align-items-center" id="ovly7">
					<span className="me-2">Name</span>
					{
						<FilterComponent
							type="search"
							array={kols}
							setArray={setFilteredData}
							value="Name"
						/>
					}
				</div>
			),
			selector: (row) => row.name,
			wrap: true,
			sortable: true,
			sortFunction: (a, b) => customStringSort(a, b, "name"),
		},
		{
			name: "Description",
			selector: (row) => row.description,
			wrap: true,
			sortable: true,
			sortFunction: (a, b) => customStringSort(a, b, "description"),
		},
		{
			name: "Action",
			selector: (row) => row.action,
		},
	];

	const data = (filteredData.length === 0 ? kols : filteredData)?.map(
		(e, index) => {
			return {
				id: e._id,
				name: e.name,
				index: index,
				description: e.description,
				action: (
					<div className="d-flex">
						<div
							className="mx-3  cursor-pointer icon-width"
							onClick={() => {
								editKol(e);
							}}
						>
							<i className="fa fa-pen"></i>
						</div>
						<div
							className="mx-3  cursor-pointer icon-width"
							onClick={() => {
								setDeleting(e._id);
								setShow(true);
							}}
						>
							<i className="fa fa-trash"></i>
						</div>
					</div>
				),
			};
		},
	);

	const customStyles = {
		headCells: {
			style: {
				justifyContent: "center",
			},
		},
		cells: {
			style: {
				justifyContent: "center",
				textAlign: "center",
			},
		},
	};

	const conditionalRowStyles = [
		{
			when: (row) => row,
			style: {
				borderWidth: "0px",
			},
		},
		{
			when: (row) => row.index % 2 === 1,
			style: {
				borderWidth: "0px",
				backgroundColor: "#f8f8f8",
			},
		},
	];

	return (
		<>
			<div className="container p-0">
				<div className="mainHeading px-4">
					<h1>Option KOL/Channel</h1>
					<Button className="addItem" onClick={addKol}>
						+ Add New
					</Button>
				</div>

				<DeleteModal
					content="Confirm KOL Deletion?"
					onYes={removeKol}
					onNo={handleClose}
					show={show}
				/>

				<DataTable
					columns={columns}
					customStyles={customStyles}
					data={data || []}
					pagination
					conditionalRowStyles={conditionalRowStyles}
				/>
			</div>
		</>
	);
}

export default OptionKol;
